import React from 'react';

import { flagStyles } from '../settings';

const SvgRU = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4536px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgRU;
